import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/components/Login";
import AdminLogin from "@/components/adminLogin";
import Home from "@/components/Home";
import ManagerHome from "@/components/managerHome";
import Setter from "@/components/Set";
import Trade from "@/components/Trade";
import Report from "@/components/Report";
import Log from "@/components/Log";
import HisDeal from "@/components/HisDeal";
import HisEntrust from "@/components/HisEntrust";
import User from "@/components/user";
import Api from "@/components/apiman";
import FuTrade from "../components/fuTrade.vue";
import TokenPage from "@/components/TokenPage";
import StatsPage from "@/components/StatsPage";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/login",
      component: Login
    },
    {
      path: "/adminLogin",
      component: AdminLogin
    },
    {
      path: "/mHome",
      component: ManagerHome,
      redirect: "/set",
      meta: { roles: ["admin"] },
      children: [
        {
          path: "/set",
          name: "set",
          component: Setter,
          meta: { roles: ["admin"], title: "权限管理", icon: "el-icon-setting" }
        },
        {
          path: "/user",
          name: "user",
          component: User,
          meta: { roles: ["admin"], title: "用户管理", icon: "el-icon-user" }
        },
        {
          path: "/api",
          name: "api",
          component: Api,
          meta: { roles: ["admin"], title: "API管理", icon: "el-icon-key" }
        }
      ]
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      // redirect: "/trade",
      meta: { roles: ["user", "admin"] },
      children: [
        {
          path: "/trade",
          name: "trade",
          component: Trade,
          meta: { roles: ["admin"], title: "现货", icon: "el-icon-s-shop" }
        },
        {
          path: "/fuTrade",
          name: "futrade",
          component: FuTrade,
          meta: { roles: ["admin"], title: "合约", icon: "el-icon-s-finance" }
        },
        {
          path: "/report",
          name: "report",
          component: Report,
          meta: { roles: ["admin", "user"], title: "报表", icon: "el-icon-s-data" },
          children: [
            {
              path: "/hisEntrust",
              name: "hisEntrust",
              component: HisEntrust,
              meta: { roles: ["user", "admin"] }
            },
            {
              path: "/hisDeal",
              name: "hisDeal",
              component: HisDeal,
              meta: { roles: ["user", "admin"] }
            },
            {
              path: "/token/:token/:exchange",
              name: "token",
              component: TokenPage,
              meta: { roles: ["user", "admin"] }
            },
            {
              path: "/stats/:token/:type",
              name: "stats",
              component: StatsPage,
              meta: { roles: ["user", "admin"] }
            }
          ]
        },
        /*{
          path: "/log",
          name: "log",
          component: Log,
          meta: { roles: ["user", "admin"], title: "日志", icon: "el-icon-document" }
        }*/
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const userRole = localStorage.getItem("userRole");
  
  if (to.path === '/home') {
    const homeRoute = router.options.routes.find(r => r.path === '/home');
    if (homeRoute && homeRoute.children) {
      const tradeRoute = homeRoute.children.find(r => r.path === '/trade');
      if (tradeRoute && tradeRoute.meta && tradeRoute.meta.roles && tradeRoute.meta.roles.includes(userRole)) {
        next({ path: '/trade' });
        return;
      }
    }
  }
  
  if (to.meta && to.meta.roles && to.meta.roles.length > 0) {
    if (!userRole || !to.meta.roles.includes(userRole)) {
      next({ path: '/trade' });
      return;
    }
  }
  next();
});

export default router;
